import React from "react";
import useSheetForm from "../hooks/useSheetForm";
import validateInfo from "../hooks/validateInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDownUpAcrossLine,
  faCircleCheck,
  faEnvelope,
  faExchange,
  faHeadset,
  faMoneyBill,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

export default function Contact() {
  const {
    handleChange,
    formData,
    handleSubmit,
    errors,
    isSubmitted,
    submitMessage,
  } = useSheetForm(validateInfo, "contactUs");

  return (
    <div className="w-full">
      <div className="md:px-40 container flex flex-col md:flex-row">
        <div className="bg-ambhosOrange rounded-xl md:w-1/2 flex flex-col items-center py-10 px-7 md:px-20 md:pt-28 md:mt-12">
          <div className="grid grid-cols-2 text-white">
            <div className="m-10 text-center space-y-5">
              <FontAwesomeIcon
                className="text-7xl text-white"
                icon={faHeadset}
              />
              <p>Customer Support</p>
            </div>
            <div className="m-10 text-center space-y-5">
              <FontAwesomeIcon
                className="text-7xl text-white"
                icon={faArrowDownUpAcrossLine}
              />
              <p>Easy Returns</p>
            </div>
            <div className="m-10 text-center space-y-5">
              <FontAwesomeIcon
                className="text-7xl text-white"
                icon={faMoneyBill}
              />
              <p>Full Refund</p>
            </div>
            <div className="m-10 text-center space-y-5">
              <FontAwesomeIcon
                className="text-7xl text-white"
                icon={faExchange}
              />
              <p>Easy Exchange</p>
            </div>
          </div>
        </div>
        <div className="md:w-1/2 py-10 px-7 md:px-20">
          <h1 className="text-2xl md:text-3xl inline-block font-semibold pb-2">
            Customer Support 24x7
          </h1>

          {isSubmitted ? (
            <div className="w-64 flex flex-col justify-center items-center h-80">
              <FontAwesomeIcon
                className="text-2xl text-green-600"
                icon={faCircleCheck}
              />
              <p className="w-56 text-center">{submitMessage}</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="max-w-md mt-6">
              <div className="mb-4">
                <label htmlFor="name" className="block font-medium mb-1">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="border border-gray-400 p-2 w-full rounded-md outline-none"
                />
                {errors.name && (
                  <small className="text-red-500">{errors.name}</small>
                )}
              </div>
              <div className="mb-4">
                <label htmlFor="email" className="block font-medium mb-1">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="border border-gray-400 p-2 w-full rounded-md outline-none"
                />
                {errors.email && (
                  <small className="text-red-500">{errors.email}</small>
                )}
              </div>
              <div className="mb-4">
                <label
                  htmlFor="mobileNumber"
                  className="block font-medium mb-1"
                >
                  Mobile Number <span className="font-normal">(optional)</span>
                </label>
                <input
                  type="text"
                  id="mobileNumber"
                  name="mobileNumber"
                  maxLength="10"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  className="border border-gray-400 p-2 w-full rounded-md outline-none"
                />
              </div>
              <div className="mb-4">
                <label htmlFor="orderId" className="block font-medium mb-1">
                  Order Id <span className="font-normal">(optional)</span>
                </label>
                <input
                  type="text"
                  id="orderId"
                  name="orderId"
                  value={formData.orderId}
                  onChange={handleChange}
                  className="border border-gray-400 p-2 w-full rounded-md outline-none"
                />
              </div>
              <div className="mb-6">
                <label htmlFor="message" className="block font-medium mb-1">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="border border-gray-400 p-2 w-full rounded-md h-32 resize-none outline-none"
                />
                {errors.message && (
                  <small className="text-red-500">{errors.message}</small>
                )}
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="bg-ambhosOrange hover:bg-orange-500 text-white font-bold py-2 px-4 rounded-md active:scale-95"
                >
                  Send Message
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
